module.exports = __webpack_public_path__ + "img/fastpaytv.79463673.png";